/* Layout */
import EnterpriseAppDetails from '@/views/enterpriseApp/details/index';
import EnterpriseApp from '@/views/enterpriseApp/index';
import Layout from '@/views/layout/Layout';

const enterpriseAppRouter = {
  path: '/manage/enterpriseApps',
  name: 'enterpriseApps',
  props: true,
  redirect: '/manage/enterpriseApps/index',
  meta: {
    icon: 'order',
    requiresAuth: true,
    role: 'user',
    title: '企业应用',
    perms: ['DeliveryApp.List']
  },
  component: Layout,
  type: 'buyers',
  hidden: false,
  children: [
    {
      path: 'index',
      name: 'enterpriseApp',
      component: EnterpriseApp,
      meta: {
        title: '应用列表',
        icon: 'enterprise-application',
        requiresAuth: true,
        perms: ['DeliveryApp.List']
      },
      hidden: false
    },
    {
      path: 'details/:appId',
      name: 'enterpriseAppDetails',
      component: EnterpriseAppDetails,
      meta: {
        title: '应用详情',
        icon: 'order',
        requiresAuth: true,
        currentActive: '/manage/enterpriseApps/index',
        perms: ['DeliveryApp.Get']
      },
      hidden: true
    }
  ]
};

export default enterpriseAppRouter;



// WEBPACK FOOTER //
// ./src/router/modules/enterpriseApp.js